import { getVenueEnv, uniqueKey } from '@/utils/helpers';
import config from '../../../config';
import axios from 'axios';

export default {
    state: uniqueKey(),
    start() {
        const env = getVenueEnv();

        if (!env) {
            return;
        }

        location.replace(
            `${config[env].oauth.url}/oauth2/auth?response_type=code&scope=openid&client_id=${config[env].oauth.clientId}&redirect_uri=${config[env].oauth.redirectUrl}&state=${this.state}`
        );
    },
    exchangeToken(code: string) {
        const env = getVenueEnv();

        if (!env) {
            return;
        }

        return axios
            .post(
                `${config[env].oauth.url}/oauth2/token`,
                `grant_type=authorization_code&code=${code}&redirect_uri=${config[env].oauth.redirectUrl}&client_id=${config[env].oauth.clientId}`
            )
            .then(response => response.data);
    },
};
